/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ArticleResponseType } from '../../models/article-response-type';
import { EditArticleAttributes } from '../../models/edit-article-attributes';
import { KeyType } from '../../models/key-type';

export interface EditArticleAttributes$Params {
  organizationSiteKey: KeyType;
  articleKey: KeyType;
      body: EditArticleAttributes
}

export function editArticleAttributes(http: HttpClient, rootUrl: string, params: EditArticleAttributes$Params, context?: HttpContext): Observable<StrictHttpResponse<ArticleResponseType>> {
  const rb = new RequestBuilder(rootUrl, editArticleAttributes.PATH, 'patch');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('articleKey', params.articleKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ArticleResponseType>;
    })
  );
}

editArticleAttributes.PATH = '/organization-sites/{organizationSiteKey}/consignee/articles/{articleKey}/edit';
